import * as ActionTypes from './types';
// Action Creators
export const setIsFetchingResources = (isFetchingResources) => ({
    type: ActionTypes.CONTEXT_DATA_SET_IS_FETCHING_RESOURCES,
    payload: isFetchingResources
});
export const setIsFetchingProviderConfigs = (isFetching) => ({
    type: ActionTypes.CONTEXT_DATA_SET_IS_FETCHING_PROVIDER_CONFIGS,
    payload: isFetching
});
export const setIsFetchingBusinessUnits = (isFetching) => ({
    type: ActionTypes.CONTEXT_DATA_SET_IS_FETCHING_BUSINESS_UNITS,
    payload: isFetching
});
export const setIsFetchingSftpFolders = (isFetching) => ({
    type: ActionTypes.CONTEXT_DATA_SET_IS_FETCHING_SFTP_FOLDERS,
    payload: isFetching
});
export const fetchContextData = () => ({
    type: ActionTypes.CONTEXT_DATA_FETCH_RESOURCES
});
export const fetchProviderConfigurationsSuccess = (providerConfigurations) => ({
    type: ActionTypes.CONTEXT_DATA_FETCH_PROVIDER_CONFIGURATIONS_SUCCESS,
    payload: providerConfigurations
});
export const fetchBusinessUnitsSuccess = (businessUnits) => ({
    type: ActionTypes.CONTEXT_DATA_FETCH_BUSINESS_UNITS_SUCCESS,
    payload: businessUnits
});
export const fetchSftpFoldersSuccess = (sftpFolders) => ({
    type: ActionTypes.CONTEXT_DATA_FETCH_SFTP_FOLDERS_SUCCESS,
    payload: sftpFolders
});
export default {
    fetchContextData
};
